import { render, staticRenderFns } from "./stock-order-detail-bonus.vue?vue&type=template&id=75c7a3ca&"
import script from "./stock-order-detail-bonus.vue?vue&type=script&lang=js&"
export * from "./stock-order-detail-bonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports